import { z } from 'zod';
/**
 * Keyset pagination, on every list endpoint, everywhere (architecture plan §19.1).
 *
 * There is no `offset` and no page number. Offset degrades linearly and is the usual
 * reason an admin table is fine in testing and unusable in month six. The cursor is
 * opaque on purpose — it encodes a sort key and an id, and clients must not read it.
 */
export const CursorQuery = z.object({
    cursor: z.string().max(512).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
/**
 * Lists return `has_more`, never a total. Counting is the expensive half of a list
 * query, and no screen in the flows needs an exact total — where one shows a count
 * ("Showing 4 of 4") it is small enough to have been fetched anyway.
 */
export const page = (item) => z.object({
    data: z.array(item),
    next_cursor: z.string().nullable(),
    has_more: z.boolean(),
});
/** The query every list endpoint takes: an opaque cursor and a bounded limit. */
export const listQuery = (defaultLimit = 20, maxLimit = 100) => z.object({
    cursor: z.string().max(512).optional(),
    limit: z.coerce.number().int().min(1).max(maxLimit).default(defaultLimit),
});
//# sourceMappingURL=pagination.js.map